import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
function openPrivateComposer(recipient, title, content) {
  if (title === void 0) {
    title = '';
  }
  if (content === void 0) {
    content = '';
  }
  const redirect = window.location.pathname + window.location.search + window.location.hash;
  const params = [['recipientUsers', String(recipient.id())], ['title', title], ['content', content], ['redirect', redirect]].filter(_ref => {
    let [, value] = _ref;
    return value !== '';
  }).map(_ref2 => {
    let [key, value] = _ref2;
    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).join('&');
  m.route.set(app.route('byobuComposer') + '?' + params);

  /*
   * Sur cette version de Byobu, le champ titre peut être créé
   * légèrement après l'ouverture du compositeur.
   */
  if (title) {
    let attempts = 0;
    const applyTitle = () => {
      const titleField = app.composer?.fields?.title;
      if (typeof titleField === 'function') {
        titleField(title);
        m.redraw();
        return;
      }
      attempts += 1;
      if (attempts < 20) {
        window.setTimeout(applyTitle, 50);
      }
    };
    window.setTimeout(applyTitle, 0);
  }
}
app.initializers.add('val-ui-post-private-message', () => {
  extend(PostControls, 'userControls', function (items, post) {
    const actor = app.session?.user;
    const recipient = post?.user?.();
    if (!actor || !recipient) return;
    if (String(actor.id()) === String(recipient.id())) return;
    if (!app.forum.attribute('canStartPrivateDiscussion')) {
      return;
    }
    const recipientBlocksPd = typeof recipient.blocksPd === 'function' && recipient.blocksPd();
    if (recipientBlocksPd && !app.forum.attribute('canStartPrivateDiscussionWithBlockers')) {
      return;
    }
    const username = recipient.username?.();
    if (!username) return;

    /*
     * Message privé simple.
     */
    items.add('val-private-message', Button.component({
      icon: 'far fa-envelope',
      className: 'Button Button--link',
      onclick() {
        openPrivateComposer(recipient);
      }
    }, 'Envoyer un message à @' + username), 60);

    /*
     * Citer/référencer ce message dans un nouveau MP.
     */
    items.add('val-private-quote', Button.component({
      icon: 'fas fa-quote-left',
      className: 'Button Button--link',
      onclick() {
        const discussion = post.discussion?.();
        if (!discussion) return;
        const discussionId = discussion.id();
        const postNumber = post.number?.();
        if (!discussionId || !postNumber) return;
        const discussionTitle = String(discussion.title?.() || '').trim() || 'Discussion #' + discussionId;
        const rawTitle = 'À propos de « ' + discussionTitle + ' »';
        const title = rawTitle.length > 80 ? rawTitle.slice(0, 77) + '…' : rawTitle;
        const content = 'Bonjour @' + username + ',\n\n' + 'À propos de votre message dans « ' + discussionTitle + ' » :\n' + '[Voir le message](/d/' + discussionId + '/' + postNumber + ')\n\n';
        openPrivateComposer(recipient, title, content);
      }
    }, 'Citer dans un message privé'), 59);
  });
});